// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Animation CSS */
.bullet-dot {
    position: absolute;
    animation: blink 1s linear infinite;
    height: 10px;
    width: 10px;
    border-radius: 10px;
    right: 4px;
    top: 6px
}

@keyframes blink {
    0% {
        opacity: 0
    }

    50% {
        opacity: .5
    }

    100% {
        opacity: 1
    }
}

.li_animate>li {
    opacity: 0;
    animation: eliment-animation .3s ease-in-out .33333s;
    animation-fill-mode: forwards
}

.li_animate>li:hover {
    z-index: 999
}

.li_animate>li:nth-child(1) {
    animation-delay: .01s
}

.li_animate>li:nth-child(2) {
    animation-delay: .04s
}

.li_animate>li:nth-child(3) {
    animation-delay: .08s
}

.li_animate>li:nth-child(4) {
    animation-delay: .12s
}

.li_animate>li:nth-child(5) {
    animation-delay: .16s
}

.li_animate>li:nth-child(6) {
    animation-delay: .2s
}

.li_animate>li:nth-child(7) {
    animation-delay: .24s
}

.li_animate>li:nth-child(8) {
    animation-delay: .28s
}

.li_animate>li:nth-child(9) {
    animation-delay: .32s
}

.li_animate>li:nth-child(10) {
    animation-delay: .36s
}

.li_animate>li:nth-child(11) {
    animation-delay: .4s
}

.li_animate>li:nth-child(12) {
    animation-delay: .44s
}

.li_animate>li:nth-child(13) {
    animation-delay: .48s
}

.li_animate>li:nth-child(14) {
    animation-delay: .52s
}

.li_animate>li:nth-child(15) {
    animation-delay: .56s
}

.li_animate>li:nth-child(16) {
    animation-delay: .6s
}

.li_animate>li:nth-child(17) {
    animation-delay: .64s
}

.li_animate>li:nth-child(18) {
    animation-delay: .68s
}

.li_animate>li:nth-child(19) {
    animation-delay: .72s
}

.li_animate>li:nth-child(20) {
    animation-delay: .76s
}

@keyframes eliment-animation {
    to {
        opacity: 1
    }
}

/* Image Effect */
.img-effect {
    background: var(--bs-primary);
    display: inline-block;
    float: none;
    position: relative;
    overflow: hidden;
}

.img-effect img {
    position: relative;
    display: block;
    min-height: 100%;
    max-width: 100%;
    opacity: 0.6;
}

.img-effect>div {
    padding: 2em;
    color: var(--bs-white);
    /* Replace \$white */
    font-size: 1rem;
    backface-visibility: hidden;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

/* --- Effect Version One --- */
.img-effect.one>div::before {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(to bottom, rgba(72, 76, 97, 0) 0%, rgba(72, 76, 97, 0.8) 75%);
    content: '';
    opacity: 0;
    transform: translate3d(0, 50%, 0);
}

.img-effect.one h2 {
    position: absolute;
    top: 50%;
    left: 0;
    width: 100%;
    transition: transform 0.35s, color 0.35s;
    transform: translate3d(0, -50%, 0);
}

.img-effect.one>div::before,
.img-effect.one p {
    transition: opacity 0.35s, transform 0.35s;
}

.img-effect.one p {
    position: absolute;
    bottom: 0;
    left: 0;
    padding: 10px;
    width: 100%;
    opacity: 0;
    transform: translate3d(0, 10px, 0);
    line-height: 20px;
}

.img-effect.one:hover h2 {
    color: #fff;
    /* Replace \$white */
    transform: translate3d(0, -50%, 0) translate3d(0, -40px, 0);
}

.img-effect.one:hover>div::before,
.img-effect.one:hover p {
    opacity: 1;
    transform: translate3d(0, 0, 0);
}

/* SVG path animated on hover */
.animated-icon path{
    stroke-dasharray: 0; /* will be overridden by JS */
    stroke-dashoffset: 0; /* visible by default */
    transition: none;
}
/* Animate on hover ONLY */
.animated-icon:hover path{
    transition: stroke-dashoffset 1s ease;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/animation.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;IACI,kBAAkB;IAClB,mCAAmC;IACnC,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,UAAU;IACV;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;IACI,UAAU;IAEV,oDAAoD;IAEpD;AACJ;;AAEA;IACI;AACJ;;AAEA;IAEI;AACJ;;AAEA;IAEI;AACJ;;AAEA;IAEI;AACJ;;AAEA;IAEI;AACJ;;AAEA;IAEI;AACJ;;AAEA;IAEI;AACJ;;AAEA;IAEI;AACJ;;AAEA;IAEI;AACJ;;AAEA;IAEI;AACJ;;AAEA;IAEI;AACJ;;AAEA;IAEI;AACJ;;AAEA;IAEI;AACJ;;AAEA;IAEI;AACJ;;AAEA;IAEI;AACJ;;AAEA;IAEI;AACJ;;AAEA;IAEI;AACJ;;AAEA;IAEI;AACJ;;AAEA;IAEI;AACJ;;AAEA;IAEI;AACJ;;AAEA;IAEI;AACJ;;AAQA;IACI;QACI;IACJ;AACJ;;AAEA,iBAAiB;AACjB;IACI,6BAA6B;IAC7B,qBAAqB;IACrB,WAAW;IACX,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;IAEf,2BAA2B;IAC3B,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;AAChB;;AAEA,+BAA+B;AAC/B;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,yFAAyF;IACzF,WAAW;IACX,UAAU;IACV,iCAAiC;AACrC;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,OAAO;IACP,WAAW;IACX,wCAAwC;IACxC,kCAAkC;AACtC;;AAEA;;IAEI,0CAA0C;AAC9C;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,aAAa;IACb,WAAW;IACX,UAAU;IACV,kCAAkC;IAClC,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,2DAA2D;AAC/D;;AAEA;;IAEI,UAAU;IACV,+BAA+B;AACnC;;AAEA,+BAA+B;AAC/B;IACI,mBAAmB,EAAE,6BAA6B;IAClD,oBAAoB,EAAE,uBAAuB;IAC7C,gBAAgB;AACpB;AACA,0BAA0B;AAC1B;IACI,qCAAqC;AACzC","sourcesContent":["/* Animation CSS */\n.bullet-dot {\n    position: absolute;\n    animation: blink 1s linear infinite;\n    height: 10px;\n    width: 10px;\n    border-radius: 10px;\n    right: 4px;\n    top: 6px\n}\n\n@keyframes blink {\n    0% {\n        opacity: 0\n    }\n\n    50% {\n        opacity: .5\n    }\n\n    100% {\n        opacity: 1\n    }\n}\n\n.li_animate>li {\n    opacity: 0;\n    -webkit-animation: eliment-animation .3s ease-in-out .33333s;\n    animation: eliment-animation .3s ease-in-out .33333s;\n    -webkit-animation-fill-mode: forwards;\n    animation-fill-mode: forwards\n}\n\n.li_animate>li:hover {\n    z-index: 999\n}\n\n.li_animate>li:nth-child(1) {\n    -webkit-animation-delay: .01s;\n    animation-delay: .01s\n}\n\n.li_animate>li:nth-child(2) {\n    -webkit-animation-delay: .04s;\n    animation-delay: .04s\n}\n\n.li_animate>li:nth-child(3) {\n    -webkit-animation-delay: .08s;\n    animation-delay: .08s\n}\n\n.li_animate>li:nth-child(4) {\n    -webkit-animation-delay: .12s;\n    animation-delay: .12s\n}\n\n.li_animate>li:nth-child(5) {\n    -webkit-animation-delay: .16s;\n    animation-delay: .16s\n}\n\n.li_animate>li:nth-child(6) {\n    -webkit-animation-delay: .2s;\n    animation-delay: .2s\n}\n\n.li_animate>li:nth-child(7) {\n    -webkit-animation-delay: .24s;\n    animation-delay: .24s\n}\n\n.li_animate>li:nth-child(8) {\n    -webkit-animation-delay: .28s;\n    animation-delay: .28s\n}\n\n.li_animate>li:nth-child(9) {\n    -webkit-animation-delay: .32s;\n    animation-delay: .32s\n}\n\n.li_animate>li:nth-child(10) {\n    -webkit-animation-delay: .36s;\n    animation-delay: .36s\n}\n\n.li_animate>li:nth-child(11) {\n    -webkit-animation-delay: .4s;\n    animation-delay: .4s\n}\n\n.li_animate>li:nth-child(12) {\n    -webkit-animation-delay: .44s;\n    animation-delay: .44s\n}\n\n.li_animate>li:nth-child(13) {\n    -webkit-animation-delay: .48s;\n    animation-delay: .48s\n}\n\n.li_animate>li:nth-child(14) {\n    -webkit-animation-delay: .52s;\n    animation-delay: .52s\n}\n\n.li_animate>li:nth-child(15) {\n    -webkit-animation-delay: .56s;\n    animation-delay: .56s\n}\n\n.li_animate>li:nth-child(16) {\n    -webkit-animation-delay: .6s;\n    animation-delay: .6s\n}\n\n.li_animate>li:nth-child(17) {\n    -webkit-animation-delay: .64s;\n    animation-delay: .64s\n}\n\n.li_animate>li:nth-child(18) {\n    -webkit-animation-delay: .68s;\n    animation-delay: .68s\n}\n\n.li_animate>li:nth-child(19) {\n    -webkit-animation-delay: .72s;\n    animation-delay: .72s\n}\n\n.li_animate>li:nth-child(20) {\n    -webkit-animation-delay: .76s;\n    animation-delay: .76s\n}\n\n@-webkit-keyframes eliment-animation {\n    to {\n        opacity: 1\n    }\n}\n\n@keyframes eliment-animation {\n    to {\n        opacity: 1\n    }\n}\n\n/* Image Effect */\n.img-effect {\n    background: var(--bs-primary);\n    display: inline-block;\n    float: none;\n    position: relative;\n    overflow: hidden;\n}\n\n.img-effect img {\n    position: relative;\n    display: block;\n    min-height: 100%;\n    max-width: 100%;\n    opacity: 0.6;\n}\n\n.img-effect>div {\n    padding: 2em;\n    color: var(--bs-white);\n    /* Replace $white */\n    font-size: 1rem;\n    -webkit-backface-visibility: hidden;\n    backface-visibility: hidden;\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n}\n\n/* --- Effect Version One --- */\n.img-effect.one>div::before {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: linear-gradient(to bottom, rgba(72, 76, 97, 0) 0%, rgba(72, 76, 97, 0.8) 75%);\n    content: '';\n    opacity: 0;\n    transform: translate3d(0, 50%, 0);\n}\n\n.img-effect.one h2 {\n    position: absolute;\n    top: 50%;\n    left: 0;\n    width: 100%;\n    transition: transform 0.35s, color 0.35s;\n    transform: translate3d(0, -50%, 0);\n}\n\n.img-effect.one>div::before,\n.img-effect.one p {\n    transition: opacity 0.35s, transform 0.35s;\n}\n\n.img-effect.one p {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    padding: 10px;\n    width: 100%;\n    opacity: 0;\n    transform: translate3d(0, 10px, 0);\n    line-height: 20px;\n}\n\n.img-effect.one:hover h2 {\n    color: #fff;\n    /* Replace $white */\n    transform: translate3d(0, -50%, 0) translate3d(0, -40px, 0);\n}\n\n.img-effect.one:hover>div::before,\n.img-effect.one:hover p {\n    opacity: 1;\n    transform: translate3d(0, 0, 0);\n}\n\n/* SVG path animated on hover */\n.animated-icon path{\n    stroke-dasharray: 0; /* will be overridden by JS */\n    stroke-dashoffset: 0; /* visible by default */\n    transition: none;\n}\n/* Animate on hover ONLY */\n.animated-icon:hover path{\n    transition: stroke-dashoffset 1s ease;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
